<template>
  <!--手机快捷登录-->
  <div id="mobilelogin">
    <h2 class="title">
      <a @click="back" class="prev"></a>
    </h2>
    <header>
      <div class="logo"></div>
    </header>
    <nav class="title">
      <router-link :to="{name: 'PwdLogin', query: {backto: this.backTo}}">学习账号登录</router-link>
      <a class="active">手机快捷登录</a>
    </nav>
    <form action="">
    <ul class="main">
      <li class="tel">
        <input type="text" name="phone" placeholder="请输入您的手机号" required="" maxlength="11" v-model.number="phone">
        <a class="getverify" v-on:click="sendMsg()" :class="{'disable': countFlag}">{{btnMsg}}</a>
      </li>
      <li class="newpwd">
        <input type="text" name="code" placeholder="请输入验证码" maxlength="6" v-model.trim="code" v-on:keyup.13="postCodeLogin">
      </li>
      <li>
        <input type="button" value="登录" @click="postCodeLogin">
      </li>
    </ul>
    </form>
    <div class="cue">
      <label><input type="checkbox" checked> 用户注册协议</label>
      <a @click="gotoForget">忘记密码？</a>
    </div>
    <!--第三方登录-->
    <div class="thirdlogin" style="display: none">
      <h2>第三方登录</h2>
      <div class="cc">
        <a href=""><img src="../../assets/icon/pwdlogin_icon_wx.png" alt="">微信</a>
        <a href=""><img src="../../assets/icon/pwdlogin_icon_qq.png" alt="">QQ</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileLogin',
  data () {
    return {
      phone: this.$store.state.logintel, // 登录手机号码
      code: '', // 登录验证码
      backTo: this.$route.query.backto ? this.$route.query.backto : '',
      countNum: 60, // 倒计时周期
      btnMsg: '获取验证码', // 默认按钮显示值
      countFlag: false, // 用于倒计时标记，true - 正在倒计时
      intervalBtn: {} // 定时器
    }
  },
  methods: {
    getPhoneCode () {
      let data = {
        phone: this.phone,
        type: 2 // 请求类型 注册(1)、登录(2)、找回密码(3)、更换手机号原手机(4)、新手机(5)、微信绑定手机号(6)
      }
      if (!data.phone) {
        alert('手机号不能为空')
        return false
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_phone_code',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            alert('短信验证码已发送，请留意查收！')
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    postCodeLogin () {
      let data = {
        phone: this.phone,
        code: this.code,
        parameter: this.$store.state.activedata
      }
      if (!data.phone) {
        alert('手机号不能为空')
        return false
      }
      if (!data.code) {
        alert('密码不能为空')
        return false
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_code_login',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200 || res.data.errcode === 20002 || res.data.errcode === 20003) {
            this.$store.dispatch('alterName', res.data.data.name)
            this.$store.dispatch('alterNickname', res.data.data.nickname)
            this.$store.dispatch('alterPeriod', res.data.data.period)
            this.$store.dispatch('alterPortrait', res.data.data.portrait)
            this.$store.dispatch('alterSchool', res.data.data.school_name)
            this.$store.dispatch('alterSubject', res.data.data.subject)
            this.$store.dispatch('alterToken', res.data.data.token)
            this.$store.dispatch('alterUid', res.data.data.uid)
            this.$store.dispatch('alterUserid', res.data.data.user_id)
            this.$store.dispatch('alterVipname', res.data.data.vip_name)
            this.$store.dispatch('alterViptime', res.data.data.vip_time)
            this.$store.dispatch('alterLoginTel', this.phone)
            console.log(this.$store.state.name)
            console.log(this.$store.state.nickname)
            console.log(this.$store.state.period)
            console.log(this.$store.state.portrait)
            console.log(this.$store.state.school)
            console.log(this.$store.state.subject)
            console.log(this.$store.state.token)
            console.log(this.$store.state.uid)
            console.log(this.$store.state.userid)
            console.log(this.$store.state.vipname)
            console.log(this.$store.state.viptime)
            console.log(this.$store.state.logintel)
            // alert('登录成功')
            if (this.backTo) {
              this.$router.push({name: this.backTo})
            } else {
              this.back()
            }
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
      return false
    },
    back () {
      if (this.backTo) {
        this.$router.push({name: this.backTo})
      } else if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    gotoForget () {
      if (this.backTo) {
        this.$router.push({name: 'PwdForget', query: {backto: this.backTo}})
      } else {
        this.$router.push({name: 'PwdForget', query: {backto: 'PersonInfo'}})
      }
    },
    // 倒计时
    countDown () {
      // this.btnMsg = this.countNum + 's重新发送'
      // 更改btn状态
      this.countFlag = true
      this.intervalBtn = setInterval(() => {
        this.btnMsg = this.countNum + 's重新发送'
        if (this.countNum <= 0) {
          this.btnMsg = '获取验证码'
          // 清除定时器
          clearInterval(this.intervalBtn)
          // 更改btn状态
          this.countFlag = false
          this.countNum = 60
        }
        // 倒计时
        this.countNum--
      }, 1000)
    },
    sendMsg () {
      if (this.countFlag) return false
      if (!this.phone) {
        alert('手机号不能为空')
        return false
      }
      if (!(/^1(3|4|5|6|7|8)\d{9}$/.test(this.phone))) {
        alert('手机号格式错误')
        return
      }
      this.countDown()
      this.getPhoneCode()
    }
  }
}
</script>

<style scoped lang="stylus">
  #mobilelogin
    h2.title
      position: absolute
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        z-index: 100
        display: block
        width: .8rem
        height: .8rem
        background-color: transparent
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #fff
          border-bottom: .03rem solid #fff
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    header
      position: relative
      width: 7.5rem
      height: 3.58rem
      background: url(../../assets/img/pwdforget_bg_head.png) no-repeat center top
      -webkit-background-size: 7.5rem 2.98rem
      background-size: 7.5rem 2.98rem
      .logo
        position: absolute
        bottom: 0
        left: 50%
        width: 1.2rem
        height: 1.2rem
        background: url(../../assets/icon/pwdforget_icon_logo.png) no-repeat center #fff
        -webkit-background-size: 1.12rem
        background-size: 1.12rem
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        -webkit-transform: translate(-50%, 0)
        -moz-transform: translate(-50%, 0)
        -ms-transform: translate(-50%, 0)
        -o-transform: translate(-50%, 0)
        transform: translate(-50%, 0)
        box-shadow:0rem 0.04rem 0.08rem 0rem rgba(172,229,255,0.3)
    nav.title
      position: relative
      display: flex
      justify-content: space-around
      align-items: center
      width: 7.5rem
      height: .56rem
      margin: .38rem 0
      text-align: center
      a
        line-height: .56rem
        font-size: .4rem
        color: #050505
        font-weight: 600
        &:nth-of-type(2)
          &::before
            content: ""
            position: absolute
            top: .02rem
            left: 50%
            width: .04rem
            height: .56rem
            background-color: #F4F4F4
            -webkit-transform: translate(-50%, 0)
            -moz-transform: translate(-50%, 0)
            -ms-transform: translate(-50%, 0)
            -o-transform: translate(-50%, 0)
            transform: translate(-50%, 0)
        &.active
          color: #1E81F2
    ul.main
      width: 7.5rem
      padding: 0 .4rem .8rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      li
        position: relative
        width: 6.7rem
        height: 1rem
        line-height: 1rem
        background: url(../../assets/icon/pwdforget_icon_user.png) no-repeat center left
        -webkit-background-size: .4rem
        background-size: .4rem
        border-bottom: .04rem solid #F3F3F3
        padding: 0 0 0 .6rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &.tel
          input
            width: 70%
        &.newpwd
          input
            width: 100%
        &:last-child
          background: none
          border: none
          padding: 0
        &:nth-of-type(2)
          background-image: url(../../assets/icon/pwdforget_icon_lock.png)
        input[type=text]
          font-size: .28rem
        input[type=button]
          width: 6.7rem
          height: .8rem
          background-color: #1E81F2
          margin-top: .6rem
          font-size: .32rem
          color: #fff
          text-align: center
          -webkit-border-radius: .4rem
          -moz-border-radius: .4rem
          border-radius: .4rem
        a.getverify
          position: absolute
          top: .2rem
          right: 0
          display: block
          width: 1.4rem
          height: .52rem
          line-height: .52rem
          border: .02rem solid #FF6100
          font-size: .24rem
          color: #FF6100
          text-align: center
          -webkit-border-radius: .26rem
          -moz-border-radius: .26rem
          border-radius: .26rem
          &.disable
            border-color: #ccc
            color: #ccc
    ::-webkit-input-placeholder
      color: #D8D8D8
    .cue
      display: flex
      justify-content: space-between
      align-items: center
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      label
        font-size: .28rem
        color: #666
        input[type=checkbox]
          position: relative
          top: -.02rem
      a
        font-size: .28rem
        color: #666
    .thirdlogin
      margin-top: 1.08rem
      h2
        position: relative
        font-size: .28rem
        color: #6666
        font-weight: 600
        text-align: center
        &::before, &::after
          content: ""
          position: absolute
          top: .2rem
          left: .48rem
          display: inline-block
          width: 2.1rem
          height: .04rem
          background-color: #F3F3F3
        &::after
          left: auto
          right: .48rem
      .cc
        display: flex
        justify-content: space-between
        align-items: center
        width: 2.78rem
        margin: .4rem auto 0
        a
          font-size: .28rem
          color: #ccc
          text-align: center
          img
            display: block
            width: .8rem
            height: .8rem
            margin: 0 auto .2rem
</style>



// WEBPACK FOOTER //
// src/components/login/MobileLogin.vue